// @flow
import type PostProcessingRule from "./PostProcessingRule";
import type Profile from "./Profile";

export class CaseBreakdownError extends Error {
    constructor(message:string, failedProcessingRule:PostProcessingRule, barcode:string, caseNumber:string = "", sampleNumber:string = "", matchingProfile:Profile = null) {
        super(message);
        this.name = "CaseBreakdownError";
        this.barcode = barcode;
        this.matchingProfile = matchingProfile;
        this.failedPostProcessingRule = failedProcessingRule;
        this.caseNumber = caseNumber;
        this.sampleNumber = sampleNumber;
    }
    
}